import React from "react";
import RegisterForm from "./RegisterForm";
import LoginForm from "./LoginForm";

export default function AuthenticatePane({
  setToken,
  isLoggedIn,
  setIsLoggedIn,
  setPrimaryCalendarId,
  setFlashMessage,
}) {
  return (
    <>
      {!isLoggedIn && (
        <div className="authenticate-backdrop backdrop">
          <div className="Authenticate-pane">
            <RegisterForm
              setToken={setToken}
              setIsLoggedIn={setIsLoggedIn}
              setFlashMessage={setFlashMessage}
              setPrimaryCalendarId={setPrimaryCalendarId}
            />
            <LoginForm
              setToken={setToken}
              setIsLoggedIn={setIsLoggedIn}
              setFlashMessage={setFlashMessage}
              setPrimaryCalendarId={setPrimaryCalendarId}
            />
          </div>
        </div>
      )}
    </>
  );
}
